import React from 'react';
import { ImageIcon, X } from 'lucide-react';

const DesignImageModal = ({ designImage, setDesignImage }) => {
  if (!designImage) return null;
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50" onClick={() => setDesignImage(null)}>
      <div className="bg-white rounded-xl shadow-2xl max-w-lg w-full mx-4 overflow-hidden" onClick={e => e.stopPropagation()} data-testid="design-image-modal">
        <div className="flex items-center justify-between px-5 py-3 border-b bg-gray-50">
          <h3 className="text-base font-bold text-gray-900">Design: {designImage.design_code}</h3>
          <button onClick={() => setDesignImage(null)} className="text-gray-400 hover:text-gray-600 p-1" data-testid="close-design-image-modal">
            <X className="h-5 w-5" />
          </button>
        </div>
        <div className="p-5">
          {designImage.loading ? (
            <div className="flex items-center justify-center py-12 text-gray-400">Loading...</div>
          ) : designImage.images.length > 0 ? (
            <div className="grid gap-3">
              {designImage.images.map((img, idx) => (
                <img key={idx} src={`${process.env.REACT_APP_BACKEND_URL}${img}`} alt={`${designImage.design_code} - ${idx + 1}`}
                  className="w-full rounded-lg object-contain max-h-[60vh]" />
              ))}
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center py-12 text-gray-400">
              <ImageIcon className="h-12 w-12 mb-2 opacity-40" />
              <p>No image available for this design</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default DesignImageModal;
